<template>
  <div>
    <div v-loading.fullscreen.lock="loading"></div>
    <div class="OrderDetails" v-if="allshow">
      <!-- 订单卡片 -->
      <order-car
        @openUser="openUser"
        class="ordercar"
        @alginGet="alginGet"
        :rowOrder="rowOrder"
      />

      <!-- 投保地块信息 -->
      <div class="toubaoMessage">
        <!-- 表格  -->
        <table-list-no
          class="tablelist"
          :rowInfoList="rowInfoList"
          :loading="loading"
        />
      </div>

      <el-dialog
        class="height"
        title="投保人信息"
        :visible.sync="showDialog"
        width="960px"
      >
        <div class="tbody" ref="listWrapper">
          <div class="box">
            <div class="messageUser">
              <span class="title"> 单位名称: </span>
              <span class="resUser">{{ coFarmInsureVO.appliName || "-" }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 单位类型: </span>
              <span class="resUser">{{
                appliType[coFarmInsureVO.appliType]
              }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 法人姓名: </span>
              <span class="resUser">{{ coFarmInsureVO.legalPerson }}</span>
            </div>

            <div class="messageUser">
              <span class="title"> 证件类型: </span>
              <span class="resUser">{{
                identifyType[coFarmInsureVO.identifyType]
              }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 证件号码: </span>
              <span class="resUser">{{ coFarmInsureVO.identifyNumber }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 证件有效期: </span>
              <span class="resUser">{{ coFarmInsureVO.validDate }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 联系人姓名 : </span>
              <span class="resUser">{{ coFarmInsureVO.linkerName }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 联系人电话: </span>
              <span class="resUser">{{
                coFarmInsureVO.phoneNumber || "-"
              }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 经营地址: </span>
              <span class="resUser">{{
                coFarmInsureVO.appliAddress || "-"
              }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 收款人姓名: </span>
              <span class="resUser">{{
                coFarmInsureVO.accountName || "-"
              }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 银行账号: </span>
              <span class="resUser">{{
                coFarmInsureVO.accountCode || "-"
              }}</span>
            </div>
            <div class="messageUser">
              <span class="title"> 银行: </span>
              <span class="resUser">{{ coFarmInsureVO.bankName || "-" }}</span>
            </div>

            <div class="messageUser">
              <span class="title"> 开户支行: </span>
              <span class="resUser">{{
                coFarmInsureVO.bankBranchName || "-"
              }}</span>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import OrderCar from "./compoments/OrderCar.vue";
import TableListNo from "./compoments/TableListNo.vue";

import initBScroll from "@/utils/bScroll";
import sameIn from "@/mixins/ruralListsdetails.js";
import { ruralInsurance } from "@/api/request/snkd.produce";
import { identify_type, appli_type } from "@/confing/map_tab.js";
export default {
  name: "OrderDetails",
  mixins: [sameIn],
  components: {
    OrderCar,
    TableListNo,
  },
  data() {
    return {
      // 是否显示
      allshow: false,
      loading: true,
      title: "意向单详情",
      // 是否显示投保人信息
      showDialog: false,
      // 卡片数据
      rowOrder: {},
      // 投保地块信息列表
      rowInfoList: [],
      coFarmInsureVO: {}, //个人信息
      identifyType: identify_type,
      appliType: appli_type,
      loading1: false,
    };
  },

  created() {
    // this.fetchInsureGetByFarmId();
    this.getOrderDetail();
  },
  // computed: {
  // },

  methods: {
    // 根据 订单id 获取订单详情
    async getOrderDetail() {
      this.loading = true;
      const { respCode, obj } = await ruralInsurance.getInsureOrderDetail({
        id: this.$route.query.id,
      });
      if (respCode === 0) {
        this.rowInfoList = obj.coFarmInsureOrderLandVOList;
        if (this.rowInfoList.length) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }

        this.rowOrder = obj.coFarmInsureOrderVO;
        this.coFarmInsureVO = obj.coFarmInsureOrderVO || {};
        this.loading = false;
        this.allshow = true;
      }
    },
    // 获取 投保人信息
    // async fetchInsureGetByFarmId() {
    //   this.loading1 = true;
    //   const res = await ruralInsurance.getInsureGetByFarmId({
    //     companyId: this.companyId,
    //     farmId: this.farmId,
    //   });
    //   try {
    //     if (res.respCode === 0) {
    //       this.coFarmInsureVO = res.obj || {};
    //       this.loading1 = false;
    //     }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    // 投保人信息
    async openUser() {
      // 打开弹出层
      this.showDialog = true;
      this.$nextTick(() => {
        initBScroll(this.$refs.listWrapper);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.OrderDetails {
  background-color: #fff;
  box-sizing: border-box;
}

.ordercar {
  padding-top: 30px;
}

.tablelist {
  padding: 0 30px 50px;
}

.listWrapper {
  position: relative;
  height: 100%;
}

.tbody {
  position: relative;
  height: 100%;

  .box {
    padding: 40px 100px;
    .messageUser {
      display: flex;
      font-size: 16px;
      color: #333;
      line-height: 56px;

      .title {
        width: 150px;
        padding-left: 150px;
      }
    }
  }
}

::v-deep .el-table {
  border: 0;
  th,
  tr,
  td {
    border: 0;
  }
  &::before {
    height: 0px;
  }
}
::v-deep .el-dialog__body {
  height: calc(100% - 54px);
  box-sizing: border-box;
  padding: 0;
}
::v-deep .el-dialog__header {
  position: relative;
  z-index: 1;
}

::v-deep .el-dialog {
  height: calc(100% - 160px);
  margin-top: 100px !important;
  overflow: hidden;

  .el-dialog__header {
    background-color: $--color-primary;
    text-align: center;

    .el-dialog__title {
      color: #fff !important;
      font-size: 20px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }
  }
}

// 滚动条样式
::v-deep .bscroll-indicator {
  background-color: #dcdfe6 !important;
}
</style>
